export const GET_VTYPES_SUCCESS  = "GET_VTYPES_SUCCESS";
export const GET_VTYPE_SUCCESS   = "GET_VTYPE_SUCCESS";
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR   = "GET_REQUEST_ERROR";
